import Column from "./default"
import { createColumn } from "./index"

export default class MergeColumn extends Column {
	#childCols

	get childCols () {
		return this.#childCols
	}

	get rowSpan () {
		let maxRowSpan = 0
		for (const col of this.childCols) {
			const rowSpan = col.rowSpan
			if (maxRowSpan < rowSpan) maxRowSpan = rowSpan
		}
		return maxRowSpan + super.rowSpan
	}

	get actualWidth () {
		return this.childCols.filter(col => !col.hidden).reduce((acc, cur) => {
			return acc + cur.actualWidth
		}, 0)
	}

	get sortable () {
		return false
	}

	get hidden () {
		return super.hidden || this.childCols.every(col => col.hidden)
	}

	constructor ({ options }) {
		super({ options })
		this.#childCols = options.children.map(childCol => {
			return createColumn(childCol)
		})
	}

	renderHeaderCell (ctx, { offsetLeft, offsetTop = 0, height }) {
		const rowSpan = this.rowSpan
		const heightForEachSpan = height / rowSpan
		const thisHeight = heightForEachSpan * super.rowSpan

		// まず、このヘッダの描画をする
		super.renderHeaderCell(ctx, { offsetLeft, offsetTop, height: thisHeight })

		// 子カラムの描画
		let offsetLeftForChild = offsetLeft
		const offsetTopForChild = offsetTop + thisHeight
		this.childCols.filter(col => !col.hidden).forEach(childCol => {
			childCol.renderHeaderCell(ctx, { offsetLeft: offsetLeftForChild, offsetTop: offsetTopForChild, height: heightForEachSpan * childCol.rowSpan })
			offsetLeftForChild += childCol.actualWidth
		})
	}

	renderCell (ctx, renderProps) {
		// throw new Error("attempt to render merged column as cell.")
	}
}
